// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__BcjHh","content":"ManualTimeModal_content__35m8j"};